import { Button, FormControl, FormControlLabel, Radio, RadioGroup, TextField } from '@mui/material'
import axios from 'axios'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import Loading from '../helper/Loading'
import { authContext } from "../../context/AuthContext";


import PageHeader from '../helper/PageHeader'

import { Editor } from '@tinymce/tinymce-react';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator'




// const imgURL = '' //process.env.REACT_APP_SERVER +"/api/image/list/tiny/"+this.props.match.params.dln
// let tinyInit = {
//     height: 500,
//     schema: 'html5-strict',
//     content_css: '/bootstrap.min.css, /pub.css',
//     valid_styles: {
//         '*': ''
//     },
//     plugins: 'template anchor link image table wordcount visualblocks lists code',
//     toolbar: "template code | anchor link | undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | table | fontsizeselect",
//     templates: [
//         { title: 'Insert Section', description: 'insert a section', content: '<section><h2>Section Heading</h2><p>section text</p></section>' },
//         { title: 'Insert Figure', description: 'insert a figure', content: '<figure class="edis-fig"><img class="img-fluid" src="select an image" alt="select an image"><figcaption class="edis-fig-cap"><span class="figure-label">Figure Label&nbsp; &nbsp;</span><span class=="caption">Figure Caption&nbsp; &nbsp;</span><span class="credit">Credit:</span></figcaption></figure>' },
//         { title: 'Insert Table Image', description: 'insert a table image', content: '<img class="img-fluid" src="select an image" alt="select an image">' },
//         { title: 'Insert Footnote', description: 'insert a footnote', content: '<div class="footnote"><p>footnote text</p></div>' }
//     ],
//     image_list: imgURL,
//     image_class_list: [
//         { title: 'img-fluid', value: 'img-fluid' },
//     ],
//     table_default_attributes: {
//         class: 'table'
//     },
//     style_formats: [
//         {
//             title: 'Headers', items: [
//                 { title: 'main title', block: 'h1' },
//                 { title: 'section heading 1', block: 'h2' },
//                 { title: 'section heading 2', block: 'h3' },
//                 { title: 'section heading 3', block: 'h4' }
//             ]
//         },
//         { title: 'p', block: 'p' }
//     ],
//     end_container_on_empty_block: true
// }

const tinyInit = {
    plugins: 'link image code',
    toolbar: 'undo redo | bold italic | alignleft aligncenter alignright | code'
}





const AdminCoursesCreateEdit = props => {
    // const [courseOptions, setCourseOptions] = useState(null)
    const [course, setCourse] = useState(null)
    const [descripVal, setDescripVal] = useState(null)
    // const [subOptions, setSubOptions] = useState(null)
    //const editorRef = useRef(null) // used to retrieve the data of the description

    const mounted = useRef(true)

    const params = useParams()
    const history = useHistory()
    const user = useContext(authContext)

    // grab course info
    useEffect(() => {
        async function fetchOptions() {
            const res = await axios.get('/api/course/' + params.id)
            console.log(res)
            if (mounted.current) {
                if (res.data.course === null) {
                    console.log("INVALID COURSE, NEED TO ADD HANDLING")
                    return
                }

                // if the imageURL is null, set it to '' instead (as the textfield throws an error if given null)
                if (res.data.course.imageUrl === null) {
                    res.data.course.imageUrl = ''
                    console.log("Fixed URL")
                }

                setCourse(res.data.course)
                setDescripVal(res.data.course.description)
            }
        }

        if (props.edit) fetchOptions()
        else {
            setCourse({
                description: '',
                enabled: true,
                hyperlink: '', //video link
                imageUrl: '',
                label: '', // the title
                passingScore: '',
                postTestLink: '',
            })
            setDescripVal('')
        }

        return () => mounted.current = false
    }, [props.edit, params.id] )

    const handleChange = event => {
        event.persist()
        const { name, value } = event.target
        setCourse(prev => ({ ...prev, [name]: value }))
    }

    const handleRadio = event => {
        event.persist()
        let { name, value } = event.target
        if (value === "true") value = true
        else value = false
        setCourse(prev => ({ ...prev, [name]: value }))
    }

    // const handleTinyChange = event => {
    //     setCourse(prev => ({ ...prev, description: event.target.getContent() }))
    // }

    // const handleEditorChange = (e) => {
    //     console.log('Content was updated:', e.target.getContent());
    //     // setCourse(prev => ({ ...prev, description: e.target.getContent()}))

    // }

    //  grabs the fields, then  posts
    // when done, goes back
    const handleSubmit = async () => {
        // const content = editorRef.current.getContent(); // the uncontrolled version, just grabs content on submit

        const url = props.edit ? '/api/course/' + params.id : '/api/course/' // the edit or create post routes
        const data = {
            ...course,
            title: course.label,
            description: descripVal, //content,
            modifiedBy: user.user.username, // only read in the edit route
            createdBy: user.user.username, // only read in the create route
        }
        // console.log(data)

        await axios.post(url, data, { headers: { Authorization: user.accessToken } })
        history.goBack()
    }

    return (
        <>
            <PageHeader title={props.edit ? "Edit Course" : "Create Course" } cancel={history.goBack} />
            {course === null ? <Loading /> :
                <ValidatorForm
                    onSubmit={handleSubmit}
                    noValidate
                >
                    <dl>
                        <dt>Title</dt>
                        <dd style={{ paddingBottom: "2rem" }}>
                            <TextValidator
                                name="label"
                                label="Title"
                                fullWidth
                                onChange={handleChange}
                                value={course.label}
                                required
                                validators={['required']}
                                errorMessages={['Title is required']}

                            />
                        </dd>

                        <dt>Status</dt>
                        <dd style={{ paddingBottom: "2rem" }}>
                            <FormControl component="fieldset">
                                <RadioGroup aria-label="enabled" name="enabled" value={course.enabled} onChange={handleRadio}>
                                    <FormControlLabel value={true} control={<Radio />} label="Enabled" />
                                    <FormControlLabel value={false} control={<Radio />} label="Disabled" />
                                </RadioGroup>
                            </FormControl>
                        </dd>

                        <dt>Image URL</dt>
                        <dd style={{ paddingBottom: "2rem" }}>
                            <TextField
                                name="imageUrl"
                                label="Image URL"
                                fullWidth
                                onChange={handleChange}
                                value={course.imageUrl}

                            />
                        </dd>

                        <dt>Course Video Link</dt>
                        <dd style={{ paddingBottom: "2rem" }}>
                            <TextValidator
                                name="hyperlink"
                                label="Course Video Link"
                                fullWidth
                                onChange={handleChange}
                                value={course.hyperlink}
                                
                            />
                        </dd>

                        <dt>Post Test URL</dt>
                        <dd style={{ paddingBottom: "2rem" }}>
                            <TextValidator
                                name="postTestLink"
                                label="Post Test URL"
                                fullWidth
                                onChange={handleChange}
                                value={course.postTestLink}
                                required
                                validators={['required']}
                                errorMessages={['Post Test URL is required']}
                            />
                        </dd>

                        <dt>Passing Score</dt>
                        <dd style={{ paddingBottom: "2rem" }}>
                            <TextValidator
                                name="passingScore"
                                label="Passing Score"
                                type="number"
                                onChange={handleChange}
                                value={course.passingScore}
                                required
                                validators={['required']}
                                errorMessages={['Passing Score is required']}
                            />
                        </dd>

                        <dt>Description</dt>
                        <dd style={{ paddingBottom: "2rem" }}>
                            {/*<TextField
                                name="description"
                                label="Description"
                                multiline
                                fullWidth
                                rows={6}
                                onChange={handleChange}
                                value={course.description}
                            /> */}


                            {/* SEE https://www.tiny.cloud/docs/integrations/react/#usingthetinymcereactcomponentasacontrolledcomponent */}
                            {/* https://www.tiny.cloud/docs/integrations/react/#usingthetinymcereactcomponentasauncontrolledcomponent */}
                            {/* Controlled version */}
                            <Editor
                                apiKey='xttygyt0upev6ellgqnoa9b3bykroxc236wqufui6numuemo'
                                initialValue={course.description}
                                // cloudChannel='dev'
                                value={descripVal}
                                init={tinyInit}
                                onEditorChange={(newValue, editor) => setDescripVal(newValue)}
                            /> 
                        </dd>
                    </dl>

                    <br />
                    <Button variant='contained' color='primary' type="submit" disabled={descripVal === ''}>Save</Button>


                </ValidatorForm>
            }
        </>
    )
}



export default AdminCoursesCreateEdit